import './CSS/Reset.css';
import AppRoutes from "./routes/routes";

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
</style>


function App() {
  return (
    <div className="App">


      <AppRoutes />
    </div>
  );
}

export default App;